interface Props {
  publication_id: string;
  email: string;
  redirect_to: string;
}

export const getSSORedirectUrl = async ({
  publication_id,
  email,
  redirect_to,
}: Props): Promise<{ redirect_url: string }> => {
  const formData = new FormData();
  formData.append('publication_id', publication_id);
  formData.append('email', email);
  formData.append('redirect_to', redirect_to);
  formData.append('should_return_redirect_url', 'true');

  const response = await fetch('/authenticate/sso_redirect', {
    method: 'POST',
    body: formData,
  });

  const data = await response.json();

  return data;
};
